import i18n from 'containers/App/i18n';

import { CustomerCreationField, customerCreationFieldKey } from '../types';

export const defaultPromotion = {
  type: 'IMAGE',
  format: 'JPG',
  src: 'https://cdn.erply.com/images/469357/March-2021-newsletter.jpg',
  duration: 2,
};

export const promoTypes = ['IMAGE', 'VIDEO'];

export const promoOptions = {
  IMAGE: ['GIF', 'JPEG', 'PNG', 'JPG'],
  VIDEO: ['OGG'],
};

export const customerCreationFields = [
  'firstName',
  'lastName',
  'email',
  'birthday',
  'zip',
  'code',
  'customerCardNumber',
  'phone',
  'mobile',
  'emailOptOut',
  'termsAndConditions',
  'privacy',
] as const;

function field(name: customerCreationFieldKey, type: string, required = false): CustomerCreationField {
  const f = { name, type, label: name, required };
  ['label', 'placeholder', 'requiredMessage', 'message', 'link'].forEach(
    property => {
      const value = i18n.t(
        `plugin-customerDisplay:registerCustomerForm.${property}.${name}`,
        { defaultValue: undefined },
      );
      if (value !== undefined) {
        f[property] = value;
      }
    },
  );
  return f;
}

export const defaultCustomerCreationFieldsDisplay: Record<
  customerCreationFieldKey,
  CustomerCreationField
> = {
  get firstName() {
    return field('firstName', 'TEXT', true);
  },
  get lastName() {
    return field('lastName', 'TEXT', true);
  },
  get email() {
    return field('email', 'EMAIL', true);
  },
  get birthday() {
    return field('birthday', 'DATE');
  },
  get zip() {
    return {
      ...field('zip', 'NUMBER'),
      signed: false,
      decimal: false,
    };
  },
  get code() {
    return field('code', 'TEXT');
  },
  get customerCardNumber() {
    return field('customerCardNumber', 'TEXT');
  },
  get phone() {
    return field('phone', 'TEXT');
  },
  get mobile() {
    return field('mobile', 'TEXT');
  },
  get emailOptOut() {
    return field('emailOptOut', 'CHEKCBOX');
  },
  get termsAndConditions() {
    return field('termsAndConditions', 'CHEKCBOX');
  },
  get privacy() {
    return field('privacy', 'CHEKCBOX');
  },
};

export const startNewSaleCentrifugoMessage = { action: 'START_NEW' };

export const hideMiscContentMessage = {
  action: 'HIDE_MISC_CONTENT',
};

export const getDonationMessage = { action: 'GET_DONATION' };

export const completePurchaseCentrifugoMessage = {
  action: 'COMPLETE_PURCHASE',
  getCustomerData: 'EMAIL',
  get message() {
    return i18n.t('plugin-customerDisplay:completePurchaseMessage');
  },
};

export const finishedSaleCentrifugoMessage = { action: 'FINISHED' };

export const customerEmailSearchMessage = { action: 'GET_CUSTOMER_EMAIL' };

export const customerPhoneSearchMessage = { action: 'GET_CUSTOMER_PHONE' };

export const customerCreationAcceptedCentrifugoMessage = {
  action: 'REGISTER_CUSTOMER_SUCCESSFUL',
};

export const enterCouponMessage = { action: 'ENTER_COUPON_CODE' };

export const couponDeclinedMessage = {
  action: 'COUPON_CODE_FAILED',
  get reason() {
    return i18n.t('plugin-customerDisplay:couponDeclinedMessage');
  },
  showAgain: false,
};

export const customerCreationRejectionMessage = {
  action: 'REGISTER_CUSTOMER_FAILED',
  get reason() {
    return i18n.t('plugin-customerDisplay:customerCreationDeclinedMessage');
  },
  showAgain: false,
};

export const posConnectedCentrifugoMessage = { action: 'POS_CONNECTED' };

export const defaultQrCodeConfig = {
  qrCodeData: 'QR Code Data Text',
  qrTitle: 'This is QR title',
  qrSubtitle: 'This is QR subtitle',
  qrTimeout: 15,
};

export const fontWeightOptions = ['REGULAR', 'SEMIBOLD', 'MEDIUM', 'BOLD'];

export const defaultFontConfig = {
  productsSummaryPrimary: {
    fontSize: 14,
    fontWeight: 'REGULAR',
  },
  productsSummarySecondary: {
    fontSize: 18,
    fontWeight: 'BOLD',
  },
};
